export default "__VITE_ASSET__D872hIJG__"